const TEHRAN_TIME_ZONE = 'Asia/Tehran'

const getTehranWallClockDate = (instant: Date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TEHRAN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(instant)
  const number = (type: string) => Number(parts.find((part) => part.type === type)?.value)
  return new Date(
    number('year'),
    number('month') - 1,
    number('day'),
    number('hour'),
    number('minute'),
    number('second')
  )
}

export {getTehranWallClockDate, TEHRAN_TIME_ZONE}
